import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AuthenticationService } from '@core/authentication';
import { AskemoTranslatePipe } from '@shared/pipes/translate/askemo-translate.pipe';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'askemo-session-expired-overlay',
    imports: [AskemoTranslatePipe, ButtonComponent, MatIcon],
    templateUrl: './session-expired-overlay.component.html',
    styleUrl: './session-expired-overlay.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionExpiredOverlayComponent {
    private readonly authService = inject(AuthenticationService);
    public readonly showLogin = this.authService.showSessionExpiredLogin;

    public login(): void {
        this.authService.loginPopup();
    }
}
